import { type Ladder, type LadderQuery, LadderSchema } from '@shefira/shared';

import { call } from './account.js';

/** One board of the ladder (ADR 0082), read with the character token. */
export async function fetchLadder(token: string, query: LadderQuery): Promise<Ladder> {
  const params = new URLSearchParams({ board: query.board, scope: query.scope });
  return call(`/ladder?${params.toString()}`, LadderSchema, { method: 'GET', token });
}
